import { put, call, takeLatest, select } from 'redux-saga/effects';
import { Types, Creators } from './categories-duck.js';
import { toast } from 'react-toastify';
import * as Api from './categories-api.js';
import { Creators as GlobalCreators } from '../globals/globals-duck.js';
import toastApiError from 'utils/api-error.js';

export const getState = (state) => state.Category;

export function* fetchAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getCategories);
    yield put(Creators.categoriesFetched(response.data));
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* createAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.createCategory, data);
    toast.success('Categoria criada com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const { id, ...rest } = data;
    yield call(Api.updateCategory, id, rest);
    toast.success('Categoria atualizada com sucesso!');
    yield put(Creators.categoriesCloseModal());
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* deleteAsync({ id }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.deleteCategory, id);
    toast.success('Categoria removida com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateOrdersAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const state = yield select(getState);
    if (!state.categoryItemsToUpdateOrder.length && !state.subCategoryItemsToUpdateOrder.length) {
      return;
    }
    if (state.categoryItemsToUpdateOrder.length) {
      yield call(Api.updateCategoryOrders, { items: state.categoryItemsToUpdateOrder });
    }
    if (state.subCategoryItemsToUpdateOrder.length) {
      yield call(Api.updateSubCategoryOrders, { items: state.subCategoryItemsToUpdateOrder });
    }
    toast.success('Ordens atualizadas com sucesso!');
    yield call(fetchAsync);
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* addSubCategoryAsync({ categoryId, data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.addSubCategory, { categoryId, ...data });
    toast.success('Subcategoria criada com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateSubCategoryAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const { id, ...rest } = data;
    yield call(Api.updateSubCategory, id, rest);
    toast.success('Subcategoria atualizada com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* deleteSubCategory({ id }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.deleteSubCategory, id);
    toast.success('Subcategoria removida com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* fetchMenuCategoriesAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getMenuCategories);
    yield put(Creators.categoriesFetchedMenuCategories(response.data));
  } catch (error) {
    toastApiError(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export default [
  takeLatest(Types.CATEGORIES_FETCH_ASYNC, fetchAsync),
  takeLatest(Types.CATEGORIES_CREATE_ASYNC, createAsync),
  takeLatest(Types.CATEGORIES_UPDATE_ASYNC, updateAsync),
  takeLatest(Types.CATEGORIES_DELETE_ASYNC, deleteAsync),
  takeLatest(Types.CATEGORIES_UPDATE_ORDERS_ASYNC, updateOrdersAsync),
  takeLatest(Types.CATEGORIES_ADD_SUB_CATEGORY_ASYNC, addSubCategoryAsync),
  takeLatest(Types.CATEGORIES_FETCH_MENU_CATEGORIES, fetchMenuCategoriesAsync),
  takeLatest(Types.SUB_CATEGORIES_UPDATE_ASYNC, updateSubCategoryAsync),
  takeLatest(Types.SUB_CATEGORIES_DELETE_ASYNC, deleteSubCategory),
];
